/* ============================================================
   TRADIE — Name, price & reviews above the product image (mobile)
   On mobile, Step One shows the title, price, and review summary
   above the product photo; everything else (fit callout, feature
   icons, bundle selector, size/fit pickers) stays below it in its
   normal place. price-title-layout.js already reassembles the
   title, reviews and price into one .product-name-wrapper block —
   this just moves that single block above .product-media, only
   below the theme's own desktop/mobile cutoff (992px — see the
   disable-below="992" attribute on <sticky-sidebar> in
   snippets/product-info.liquid). On desktop it restores it back to
   exactly where the theme originally rendered the title.

   Re-runs on any DOM change (via MutationObserver) as well as on
   breakpoint crossings, because switching colour/variant can
   re-render the title/price block from scratch — a fresh element
   that hasn't been moved yet, even though the page is still in
   mobile view. State (whether a given title wrapper has already
   been moved, and where to restore it to) is stored directly on
   the DOM node rather than in a module-level variable, so it's
   automatically correct again whenever the theme swaps in a new
   node.
   ============================================================ */

(function () {
  var mq = window.matchMedia('(max-width: 991px)');

  function sync() {
    var titleWrapper = document.querySelector('.product-name-wrapper');
    var media = document.querySelector('.product-media');
    if (!titleWrapper || !media || !media.parentNode) return;

    var isMoved = titleWrapper.classList.contains('pf-mobile-header-block');

    if (mq.matches && !isMoved) {
      var anchor = document.createComment('pf-mobile-header-anchor');
      titleWrapper.parentNode.insertBefore(anchor, titleWrapper);
      titleWrapper._pfMobileAnchor = anchor;
      titleWrapper.classList.add('pf-mobile-header-block');
      media.parentNode.insertBefore(titleWrapper, media);
    } else if (!mq.matches && isMoved) {
      var savedAnchor = titleWrapper._pfMobileAnchor;
      titleWrapper.classList.remove('pf-mobile-header-block');
      if (savedAnchor && savedAnchor.parentNode) {
        savedAnchor.parentNode.insertBefore(titleWrapper, savedAnchor);
        savedAnchor.remove();
      }
      titleWrapper._pfMobileAnchor = null;
    }
  }

  document.addEventListener('DOMContentLoaded', sync);

  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync); // Safari <14 fallback
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
